import type { IndustryContent } from '@/types/content';

export const pressureWashingContent: IndustryContent = {
  slug: 'pressure-washing',
  name: 'Pressure Washing',
  headline: 'The Operating System for Pressure Washing Companies',
  subheadline:
    'Quote jobs faster, manage equipment, and build recurring revenue—all from one platform built for pressure washing pros.',
  heroImageUrl: '/images/industries/pressure-washing-hero.webp',
  painPoints: [
    {
      title: 'Quoting takes too long',
      description:
        'Driving to every property for an estimate eats your day. And by the time you send the quote, customers have moved on.',
      icon: 'estimate',
    },
    {
      title: 'Equipment maintenance surprises',
      description:
        'Pumps fail mid-job, hoses burst, and trailers need service. Breakdowns cost you jobs and money.',
      icon: 'equipment',
    },
    {
      title: 'Seasonal feast or famine',
      description:
        'Spring is slammed, winter is dead. Building year-round revenue feels impossible.',
      icon: 'calendar',
    },
    {
      title: 'Upsells happen randomly',
      description:
        'Driveway customers could use house washes. Deck customers need sealing. But crews forget to ask.',
      icon: 'upsell',
    },
    {
      title: 'Before/after photos are scattered',
      description:
        'Great work deserves documentation, but photos live on personal phones and never make it to marketing.',
      icon: 'camera',
    },
  ],
  features: [
    {
      title: 'Satellite Estimating',
      description:
        'Measure driveways, decks, and siding from satellite imagery. Send quotes in minutes, not days.',
      icon: 'estimate',
    },
    {
      title: 'Equipment Tracking',
      description:
        'Track pump hours, schedule maintenance, and monitor equipment across all rigs. Prevent costly breakdowns.',
      icon: 'equipment',
    },
    {
      title: 'Recurring Service Plans',
      description:
        'Build annual maintenance programs. Auto-schedule house washes, driveway cleaning, and deck treatments.',
      icon: 'recurring',
    },
    {
      title: 'Upsell Prompts',
      description:
        'Surface-specific upsell suggestions appear at the right time. Soft wash the house while doing the driveway.',
      icon: 'upsell',
    },
    {
      title: 'Photo Documentation',
      description:
        'Required before/after photos on every job. Build a portfolio automatically for marketing.',
      icon: 'camera',
    },
    {
      title: 'Chemical & Supply Tracking',
      description:
        'Track chemical usage per job. Know your true costs and when to reorder.',
      icon: 'inventory',
    },
  ],
  testimonial: {
    id: 'pressure-washing-1',
    quote:
      'Satellite estimating changed everything. I send quotes while competitors are still driving to the property. My close rate went from 40% to 65%.',
    author: 'Brian Foster',
    role: 'Owner',
    company: 'Foster Power Wash',
    industry: 'pressure-washing',
    stats: {
      label: 'Close Rate Increase',
      value: '+25%',
    },
  },
  stats: [
    { label: 'Faster Quotes', value: '80%' },
    { label: 'Close Rate Improvement', value: '+25%' },
    { label: 'Equipment Downtime', value: '-50%' },
    { label: 'Recurring Revenue', value: '+40%' },
  ],
  seo: {
    title: 'Pressure Washing Software | Estimating & Scheduling | Omniforge',
    description:
      'Pressure washing software for power wash companies. Satellite estimating, equipment tracking, and recurring service management. Start your free trial.',
    keywords: [
      'pressure washing software',
      'power washing software',
      'pressure washing business software',
      'pressure washing estimating',
      'pressure washing scheduling',
    ],
  },
};
